var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-container"},[_c('div',{staticClass:"video-container"},[_c('video',{ref:"myVideo",attrs:{"preload":"none","controls":"","width":"100%","height":"100%"}},[_c('source',{attrs:{"type":"video/mp4"}}),_vm._v(" Your browser does not support the video tag. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }